<template>
    <div class="operation-bar-wrapper">
        <div class="operate-content">
            <Select :initValue="initGroup" :options="getGroupOptions" class="status-select" @menuClick="groupSelect" />
            <Search :placeholder="nameHolder" class="name-search" @searchChange="nameSearch" @inputChange="nameSearch"></Search>
            <Search :placeholder="accountHolder" class="account-search" @searchChange="accountSearch" @inputChange="accountSearch"></Search>
            <RoundButton @btnClick="addAccountHandle" :text="addAccount" />
        </div>
    </div>
</template>

<script>
import RoundButton from "@/views/zhiji/bComponents/buttons/RoundButton";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import accountEditModal from "./accountEditModal";

import { groupOptions } from "../../personConfig.js";
import { debounce } from "@/views/zhiji/js/common/util.js";

/* eslint-disable */
export default {
    name: "OperationBar",
    props: [],
    components: {
        Select,
        Search,
        RoundButton
    },
    data() {
        return {
            curPage: 1,
        };
    },
    computed: {
        querySetting() {
            return this.getStorePorp("querySetting");
        },
        initGroup() {
            return this.querySetting.group || "all"
        },
        addAccount() {
            return this.$t("zhiji.personnel.addBtnLabel")
        },
        nameHolder() {
            return this.$t("zhiji.personnel.accountManage.nameHolderTip");
        },
        accountHolder() {
            return this.$t("zhiji.personnel.accountManage.accountHolderTip");
        },
        getGroupOptions() {
            let options = [...this.getStorePorp("groupOption")];

            if (!options.length) {
                options.push(...groupOptions());
                this.$store.dispatch("zhiji/initGroupOption");
            } else {
                // 账号管理弹框改成了暂不选择分组，但是这里依旧要保持所有分组
                options.splice(0, 1, ...groupOptions());
            }

            return options;
        },
    },
    watch: {
        // 监控中英文切换，重新从后台取对应语言数据
        nameHolder() {
            this.$store.commit("zhiji/clearGroupOption");
            this.$store.commit("zhiji/clearRoleOption");
        }
    },
    mounted() {
        this.searchHanlder = debounce((data) => {
            let [searchField, searchType] = [data[0], data[1]];
            searchType === "account" ? this.searchByAccount(searchField, searchType) : this.searchByName(searchField, searchType);
        }, 500);
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.personnelManage[propName];
        },
        groupSelect(data) {
            this.$emit("searchHandle");
            this.$store.dispatch("zhiji/queryAccountList", {
                page: this.curPage,
                group: data.value,
            });
        },
        nameSearch(data) {
            this.searchHanlder(data, "name");
        },
        accountSearch(data) {
            this.searchHanlder(data, "account");
        },
        addAccountHandle() {
            this.$store.dispatch("zhiji/showModal", {
                type: accountEditModal,
                data: ""
            });
        },
        searchByAccount(data, type) {
            this.$emit("searchHandle");
            this.$store.dispatch("zhiji/queryAccountList", {
                page: this.curPage,
                email: data.value,
            });
        },
        searchByName(data, type) {
            this.$emit("searchHandle");
            this.$store.dispatch("zhiji/queryAccountList", {
                page: this.curPage,
                accountName: data.value,
            });
        }
    }
};
</script>

<style lang="less" scoped>
.operation-bar-wrapper {
    padding: 16px 24px 16px 0;
    background: #fff;
    border-bottom: 1px solid #d8e4f0;
    margin-bottom: 16px;

    .operate-content {
        display: flex;
        align-items: center;

        .name-search,
        .account-search {
            margin-right: 10px;
            font-size: 14px;
            width: 200px;
            height: 32px;
        }

        .account-search {
            margin-right: 30px;
        }
    }
}
</style>
